import { animate, motion, useMotionValue, useTransform } from 'framer-motion';
import { useEffect } from 'react';
import gameAssets from '@themed-assets';
import {
  COLOR_BG,
  COLOR_GREEN,
  COLOR_RED,
  COLOR_YELLOW
} from "@/src/constants/StatsCornerConstants";
const GAP_ANGLE = 28;
const START_ANGLE = 199;
const ARC_SPAN = 360 - GAP_ANGLE;

const getBackground = (type, progress, deg) => {
  const arcStart = START_ANGLE;
  if (type === 'vpip') {
    if (progress <= 25) {
      return `conic-gradient(
        from ${arcStart}deg,
        ${COLOR_GREEN} 0deg,
        ${COLOR_GREEN} ${deg}deg,
        ${COLOR_BG} ${deg}deg 360deg
      )`;
    } else if (progress <= 45) {
      const greenDeg = (25 / 100) * ARC_SPAN;
      return `conic-gradient(
        from ${arcStart}deg,
        ${COLOR_GREEN} 0deg,
        ${COLOR_GREEN} ${deg - greenDeg}deg,
        ${COLOR_YELLOW} ${deg}deg,
        ${COLOR_BG} ${deg}deg 360deg
      )`;
    } else {
      const greenDeg = (25 / 100) * ARC_SPAN;
      return `conic-gradient(
        from ${arcStart}deg,
        ${COLOR_GREEN} 0deg,
        ${COLOR_YELLOW} ${deg - greenDeg}deg,
        ${COLOR_RED} ${deg}deg,
        ${COLOR_BG} ${deg}deg 360deg
      )`;
    }
  } else {
    if (progress <= 15) {
      return `conic-gradient(
        from ${arcStart}deg,
        ${COLOR_RED} 0deg,
        ${COLOR_RED} ${deg}deg,
        ${COLOR_BG} ${deg}deg 360deg
      )`;
    } else if (progress <= 40) {
      const redDeg = (15 / 100) * ARC_SPAN;
      return `conic-gradient(
        from ${arcStart}deg,
        ${COLOR_RED} 0deg,
        ${COLOR_RED} ${deg - redDeg}deg,
        ${COLOR_GREEN} ${deg}deg,
        ${COLOR_BG} ${deg}deg 360deg
      )`;
    } else {
      const greenDeg = (15 / 100) * ARC_SPAN;
      return `conic-gradient(
        from ${arcStart}deg,
        ${COLOR_RED} 0deg,
        ${COLOR_GREEN} ${deg - greenDeg}deg,
        ${COLOR_YELLOW} ${deg}deg,
        ${COLOR_BG} ${deg}deg 360deg
      )`;
    }
  }
};

const CircularProgressBar = ({ progress = 0, type }) => {
  const progressMotion = useMotionValue(0);

  useEffect(() => {
    const controls = animate(progressMotion, progress, {
      duration: 1.2,
      ease: 'easeInOut'
    });
    return controls.stop;
  }, [progress, progressMotion]);

  const filledAngle = useTransform(
    progressMotion,
    (val) => (val / 100) * ARC_SPAN
  );

  const background = useTransform(filledAngle, (deg) =>
    getBackground(type, progress, deg)
  );

  const displayText = useTransform(progressMotion, (p) => `${Math.round(p)}%`);

  return (
    <div className="relative flex h-[58px] w-[58px] items-center justify-center rounded-full">
      <motion.div
        className="relative flex h-[58px] w-[58px] items-center justify-center rounded-full"
        style={{ background }}
      ></motion.div>

      <img
        src={gameAssets.radialEllipse}
        className="absolute z-[1] h-full w-full rounded-full object-cover"
        alt="Radial Ellipse"
        draggable={false}
      />

      <motion.div className="text-primary text-14 absolute z-[2] font-bold">
        <motion.span>{displayText}</motion.span>
      </motion.div>
      <div className="bg-info/10 h-full w-full absolute rounded-full"></div>
    </div>
  );
};

export default CircularProgressBar;